import API from '@/api/user';
import { userManager, getUser, setUser } from '@/utils/auth';

export default {
  createUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.createUser(payload)
        .then((response) => {
          const { data } = response || {};
          commit('setLoading', false);
          resolve(data);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  updateActiveState({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.updateActiveState(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },
  bulkUpsertValidate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.bulkUpsertValidate(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  getBulkCsvDownload({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);
      API.getBulkCsvDownload(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  createCsvUsers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.createCsvUsers(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  getDownloadInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.getDownloadInfo(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  getCurrentUserSelf({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.getCurrentUserSelf(payload)
        .then((response) => {
          commit('setLoading', false);
          commit('setRedemption', response.data);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  assignRedemptionCode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.assignRedemptionCode(payload)
        .then((response) => {
          commit('setLoading', false);
          commit('setRedemption', response.data);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  downloadAndroid({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.downloadAndroid(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  downloadWindows({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.downloadWindows(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  getNotificationsForUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.getNotificationsForUser(payload)
        .then((response) => {
          commit('setLoading', false);
          commit('setNotifications', response.data);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  adminResetPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.adminResetPassword(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },

  getUsersHavingAssignedCourseIds({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      API.getUsersHavingAssignedCourseIds(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getOfflineStatus({ commit }) {
    return new Promise((resolve, reject) => {
      API.getOfflineStatus()
        .then((response) => {
          // only when 200, API is scheduled to be taken offline
          if (response.status === 200) {
            commit('setOfflineStatus', response.data);
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getFaqUrl({ commit }, role) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      API.getFaqUrl(role ?? null)
        .then((res) => {
          commit('setLoading', false);
          resolve(res);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  getAssetByUrl({ commit }, url) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      API.getAssetByUrl(url)
        .then((res) => {
          commit('setLoading', false);
          resolve(res);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  refreshAccessToken({ commit }) {
    return new Promise((resolve, reject) => {
      userManager
        .signinSilent()
        .then((res) => {
          setUser(res);
          const user = getUser();
          commit('setCurrentUser', user);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  declareAnswerOverrideAuthByUnifierId({ commit }, payload) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      API.declareAnswerOverrideAuthorization({
        courseUnifierId: payload.courseUnifierId,
        orgId: payload.orgId,
      })
        .then((res) => {
          commit('setLoading', false);
          resolve(res);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  getBannerMessages({ commit }, payload) {
    return new Promise((resolve, reject) => {
      API.getBannerMessages(payload)
        .then((res) => {
          commit('setBannerMessages', res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getMarketingMessages({ commit }, payload) {
    return new Promise((resolve, reject) => {
      API.getMarketingMessages(payload)
        .then((res) => {
          commit('setMarketingMessages', res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
